import { useRef } from "react";

// Icon
import ListIcon from "assets/icons/glory/list.svg?react";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type ProviderFilterSelectProps = {
  providers: string[] | null;
  onClick: () => void;
};

const ProviderFilterSelect = (props: ProviderFilterSelectProps) => {
  const { providers, onClick } = props;
  const valueRef = useRef<HTMLDivElement>(null);

  const t = useTranslate();

  const providersName =
    providers && providers.length
      ? `${t("casino.providers.selected")} : ${providers.length}`
      : `${t("casino.providers.category.all")}`;

  return (
    // eslint-disable-next-line react/jsx-handler-names
    <div className="ProviderFilterSelect" onClick={onClick}>
      <span className="ProviderFilterSelect__value" ref={valueRef}>
        {providersName}
      </span>
      <div className="ProviderFilterSelect__icon">
        <ListIcon />
      </div>
    </div>
  );
};

export default ProviderFilterSelect;
